import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { globalStyles, noop } from '@client/shared/constants';
import style from './style';
import MicIcon from '@mui/icons-material/Mic';
import StopOutlinedIcon from '@mui/icons-material/StopOutlined';

const RecorderView = ({
  initRecording = false,
  canvasRef = {},
  recordedVoicemailTitle = '',
  saveRecording = noop,
  startRecording = noop,
  handleChange = noop
}) => {
  return (
    <>
      <Box
        sx={{
          mt: 4
        }}
      >
        <Typography
          variant='body2'
          sx={{
            mb: 1,
            ...globalStyles.text.weight.bold,
          }}
        >
          New Recording
        </Typography>
        <Box
          sx={{
            mt: 2
          }}
        >
          <Box
              sx={{
              ...globalStyles.display.flex,
              ...globalStyles.flex.justify.between,
              mt: 2
            }}
          >
            <TextField
              disabled={initRecording}
              size='small'
              placeholder="Add Title..."
              name="recordedVoicemailTitle"
              value={recordedVoicemailTitle}
              onChange={handleChange}
              sx={{
                mr: 2,
                ...globalStyles.width["80"]
              }}
            />
            <Button
              disabled={initRecording}
              variant="contained"
              startIcon={<MicIcon />}
              onClick={startRecording}
              sx={{
                ...style.recordingActions
              }}
            >
              Record
            </Button>
          </Box>
          <Box
              sx={{
              ...globalStyles.display.flex,
              ...globalStyles.flex.justify.between,
              ...globalStyles.flex.align.center,
              mt: 2
            }}
          >
            {initRecording ? (
                <>
                  <canvas ref={canvasRef} width={408} height={20}></canvas>
                  <img alt="Recording Icon" src="/assets/recording.gif" height={36} />
                </>
            ) : <Box />}
            <Button
              disabled={!initRecording}
              variant="contained"
              startIcon={<StopOutlinedIcon />}
              onClick={saveRecording}
              sx={{
                ...style.recordingActions,
                ...(initRecording ? style.stopBtn : {})
              }}
            >
              Stop
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default RecorderView;